import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/* eslint-disable @tencent/i18next/no-literal-string */
import { DRIVE_TYPE, DriveData, PadInfo } from '@tencent/ark-model';
import { DriveDataStorage, PadInfoStorage } from '@tencent/ark-storage';
import { getUid } from '@tencent/docs-login';
import { isImageLike } from '@tencent/docs-mime-types';
import { fetchFileInfo, fetchPreviewInfo, FileInfoFetchType, PreviewInfoFetchType } from "../../drive-api";
import { TaskManager } from "./drive-data-api-task-manager";
import { SendMessageToServiceWorker } from "./service-worker";
import { isAttachment, isTencentDocHost, resolveUrl } from "./utils";

// 解构出参数类型供使用

export var DriveDataApi = /*#__PURE__*/function () {
  // callback是为了drive中品类预览态的进一步缓存而存在的
  function DriveDataApi(storageManager, log) {
    _classCallCheck(this, DriveDataApi);
    _defineProperty(this, "messageCenter", void 0);
    _defineProperty(this, "taskManager", new TaskManager());
    this.storageManager = storageManager;
    this.log = log;
    this.log.info(DriveDataApi.TAG, '初始化完成');
    this.messageCenter = new SendMessageToServiceWorker(this.log);
  }

  /**
   * 品类批量缓存附件, 会返回一个值表示是否全部缓存成功，只要有一个失败会返回false
   * @param padId 品类padId
   * @param objKeys attachment 的id的数组结构
   * @returns 返回是否全部缓存成功
   */
  _createClass(DriveDataApi, [{
    key: "cacheBatchAttachmentData",
    value: function () {
      var _cacheBatchAttachmentData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(padId, objKeys) {
        var _this = this;
        var secretId,
          driveDataList,
          staticList,
          cacheRes,
          resultList,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              secretId = _args.length > 2 && _args[2] !== undefined ? _args[2] : '';
              _context.next = 3;
              return Promise.all(objKeys.map(function (objKey) {
                return _this.requestDriveData({
                  fileId: padId,
                  objKey: objKey,
                  secretId: secretId
                });
              }));
            case 3:
              driveDataList = _context.sent;
              if (!driveDataList.some(function (t) {
                return t === null;
              })) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", false);
            case 6:
              // 第二步，获得所有静态资源链接
              staticList = [];
              driveDataList.forEach(function (driveData) {
                var _getPwaResFromDriveDa = getPwaResFromDriveData(driveData),
                  sList = _getPwaResFromDriveDa.staticList;
                staticList.push.apply(staticList, _toConsumableArray(sList));
              });

              // 第三步，将静态资源缓存pwa
              _context.next = 10;
              return this.addUriToPWA(staticList);
            case 10:
              cacheRes = _context.sent;
              if (cacheRes) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", false);
            case 13:
              // 第三步: 将数据存入库中
              this.log.info(DriveDataApi.TAG, "\u5B58\u5165\u6570\u636E\u5E93drive\u9644\u4EF6\u4FE1\u606F, padId = ".concat(padId));
              // eslint-disable-next-line function-paren-newline
              _context.next = 16;
              return Promise.all(driveDataList.map(function (driveData) {
                return _this.updateCacheDriveData(driveData);
              }));
            case 16:
              resultList = _context.sent;
              if (!resultList.some(function (t) {
                return !t;
              })) {
                _context.next = 19;
                break;
              }
              return _context.abrupt("return", false);
            case 19:
              return _context.abrupt("return", true);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function cacheBatchAttachmentData(_x, _x2) {
        return _cacheBatchAttachmentData.apply(this, arguments);
      }
      return cacheBatchAttachmentData;
    }()
    /**
     * 手动缓存drive文件
     * @param options fileId为必填项, 为了数据库数据完整性，secretId最好也传入，附件必传objKey
     * @returns Promise<DriveData | null>
     */
  }, {
    key: "cacheDriveData",
    value: function () {
      var _cacheDriveData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
        var _options$secretId, _options$objKey;
        var fileId, secretId, objKey, driveData, _getPwaResFromDriveDa2, staticList, cacheRes, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              fileId = options.fileId;
              secretId = (_options$secretId = options.secretId) !== null && _options$secretId !== void 0 ? _options$secretId : '';
              objKey = (_options$objKey = options.objKey) !== null && _options$objKey !== void 0 ? _options$objKey : ''; // 第一步: 获取fileInfo和query的数据
              _context2.next = 5;
              return this.requestDriveData({
                fileId: fileId,
                secretId: secretId,
                objKey: objKey
              });
            case 5:
              driveData = _context2.sent;
              if (driveData) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return", null);
            case 8:
              // 第二步: 将preview的各种资源url地址存入pwa中
              _getPwaResFromDriveDa2 = getPwaResFromDriveData(driveData), staticList = _getPwaResFromDriveDa2.staticList;
              _context2.next = 11;
              return this.addUriToPWA(staticList);
            case 11:
              cacheRes = _context2.sent;
              if (cacheRes) {
                _context2.next = 14;
                break;
              }
              return _context2.abrupt("return", null);
            case 14:
              // 第三步: 将数据存入库中
              this.log.info(DriveDataApi.TAG, "\u5B58\u5165\u6570\u636E\u5E93drive\u6587\u4EF6\u4FE1\u606F, fileId = ".concat(fileId, " objKey = ").concat(objKey));
              _context2.next = 17;
              return this.updateCacheDriveData(driveData);
            case 17:
              result = _context2.sent;
              if (result) {
                _context2.next = 20;
                break;
              }
              return _context2.abrupt("return", null);
            case 20:
              return _context2.abrupt("return", driveData);
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function cacheDriveData(_x3) {
        return _cacheDriveData.apply(this, arguments);
      }
      return cacheDriveData;
    }()
  }, {
    key: "updateCacheDriveData",
    value: function () {
      var _updateCacheDriveData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(data) {
        var _this2 = this;
        var driveDataCollection, driveInfoStorage, driveId;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              driveDataCollection = this.storageManager.storage.collection(DriveData);
              driveInfoStorage = new DriveDataStorage(driveDataCollection);
              driveId = data.driveId;
              if (driveId) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", false);
            case 5:
              return _context4.abrupt("return", new Promise(function (rs) {
                _this2.taskManager.addTask({
                  run: function () {
                    var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                      var dataFromDB, newData;
                      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while (1) switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return driveInfoStorage.getDriveData({
                              driveId: driveId
                            });
                          case 3:
                            dataFromDB = _context3.sent;
                            if (!dataFromDB) {
                              _context3.next = 7;
                              break;
                            }
                            _context3.next = 7;
                            return driveInfoStorage.deleteDriveDatas({
                              driveId: driveId
                            });
                          case 7:
                            newData = _objectSpread(_objectSpread({}, dataFromDB), data);
                            _context3.next = 10;
                            return driveInfoStorage.insertDriveDatas([newData]);
                          case 10:
                            _this2.log.log(DriveDataApi.TAG, 'drive文件信息存入/更新数据库成功, driveData: ', newData);
                            rs(true);
                            _context3.next = 18;
                            break;
                          case 14:
                            _context3.prev = 14;
                            _context3.t0 = _context3["catch"](0);
                            _this2.log.warn(DriveDataApi.TAG, 'drive文件信息存入/更新数据库失败, message: ', _context3.t0);
                            rs(false);
                          case 18:
                          case "end":
                            return _context3.stop();
                        }
                      }, _callee3, null, [[0, 14]]);
                    }));
                    function run() {
                      return _run.apply(this, arguments);
                    }
                    return run;
                  }()
                });
              }));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateCacheDriveData(_x4) {
        return _updateCacheDriveData.apply(this, arguments);
      }
      return updateCacheDriveData;
    }()
  }, {
    key: "getPadInfoFromLocal",
    value: function () {
      var _getPadInfoFromLocal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(secretId) {
        var _getUid;
        var padInfoCollection, padInfoStorage;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.log.info(DriveDataApi.TAG, "\u4ECE\u6570\u636E\u5E93\u67E5\u8BE2\u6587\u6863 pad info \u4FE1\u606F, secretId = ".concat(secretId));
              padInfoCollection = this.storageManager.storage.collection(PadInfo);
              padInfoStorage = new PadInfoStorage(padInfoCollection);
              return _context5.abrupt("return", padInfoStorage.getPadInfo((_getUid = getUid()) !== null && _getUid !== void 0 ? _getUid : '', secretId));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getPadInfoFromLocal(_x5) {
        return _getPadInfoFromLocal.apply(this, arguments);
      }
      return getPadInfoFromLocal;
    }()
  }, {
    key: "getCacheDriveData",
    value: function () {
      var _getCacheDriveData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(options) {
        var driveDataCollection, driveInfoStorage, dataFromDB;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              driveDataCollection = this.storageManager.storage.collection(DriveData);
              driveInfoStorage = new DriveDataStorage(driveDataCollection);
              _context6.prev = 2;
              _context6.next = 5;
              return driveInfoStorage.getDriveData(options);
            case 5:
              dataFromDB = _context6.sent;
              if (dataFromDB) {
                _context6.next = 8;
                break;
              }
              throw new Error('Cant find DB Data');
            case 8:
              this.log.info(DriveDataApi.TAG, '获取离线数据DriveData成功, DriveData = ', dataFromDB);
              return _context6.abrupt("return", dataFromDB);
            case 12:
              _context6.prev = 12;
              _context6.t0 = _context6["catch"](2);
              this.log.warn(DriveDataApi.TAG, '获取离线数据DriveData失败, error = ', _context6.t0, 'options = ', options);
              return _context6.abrupt("return", null);
            case 16:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[2, 12]]);
      }));
      function getCacheDriveData(_x6) {
        return _getCacheDriveData.apply(this, arguments);
      }
      return getCacheDriveData;
    }()
  }, {
    key: "deleteCacheDriveData",
    value: function () {
      var _deleteCacheDriveData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(options) {
        var driveDataCollection, driveInfoStorage;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(Object.keys(options).length === 0)) {
                _context7.next = 3;
                break;
              }
              this.log.warn(DriveDataApi.TAG, '删除缓存数据失败, 原因: options为空');
              return _context7.abrupt("return", false);
            case 3:
              driveDataCollection = this.storageManager.storage.collection(DriveData);
              driveInfoStorage = new DriveDataStorage(driveDataCollection);
              _context7.prev = 5;
              _context7.next = 8;
              return driveInfoStorage.deleteDriveDatas(options);
            case 8:
              this.log.info(DriveDataApi.TAG, '删除数据库drive文件信息成功, options = ', options);
              _context7.next = 15;
              break;
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](5);
              this.log.warn(DriveDataApi.TAG, '删除数据库drive文件信息失败, options = ', options, 'message: ', _context7.t0);
              return _context7.abrupt("return", false);
            case 15:
              return _context7.abrupt("return", true);
            case 16:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[5, 11]]);
      }));
      function deleteCacheDriveData(_x7) {
        return _deleteCacheDriveData.apply(this, arguments);
      }
      return deleteCacheDriveData;
    }()
    /**
     * 该函数会返回是否缓存成功的结果的boolean，promise始终是resolved
     */
  }, {
    key: "addUriToPWA",
    value: function addUriToPWA(fileUrlList) {
      var _this3 = this;
      this.log.log(DriveDataApi.TAG, '开始缓存PWA资源, fileUrlList = ', fileUrlList);
      return new Promise(function (rs) {
        _this3.messageCenter.sendMessage({
          type: 'preload:cache-doc-media',
          data: {
            fileList: fileUrlList
          }
        }, /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(data) {
            var _data$data;
            return _regeneratorRuntime().wrap(function _callee8$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  if (data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.result) {
                    _this3.log.log(DriveDataApi.TAG, '资源缓存PWA成功, data = ', data);
                    rs(true);
                  } else {
                    _this3.log.warn(DriveDataApi.TAG, '资源缓存PWA失败, data = ', data);
                    rs(false);
                  }
                case 1:
                case "end":
                  return _context8.stop();
              }
            }, _callee8);
          }));
          return function (_x8) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    }
  }, {
    key: "requestDriveData",
    value: function () {
      var _requestDriveData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(options) {
        var _options$secretId2, _options$objKey2, _getUid2;
        var fileId, secretId, objKey, previewInfo, fileInfo, type, _yield$Promise$all, _yield$Promise$all2, fileInfoRsp, previewInfoRsp, driveId, driveData;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              fileId = options.fileId;
              secretId = (_options$secretId2 = options.secretId) !== null && _options$secretId2 !== void 0 ? _options$secretId2 : '';
              objKey = (_options$objKey2 = options.objKey) !== null && _options$objKey2 !== void 0 ? _options$objKey2 : ''; // 第一步: 获取fileInfo和query的数据
              _context9.prev = 3;
              _context9.next = 6;
              return Promise.all([fetchFileInfo({
                fileId: fileId,
                objKey: objKey
              }, FileInfoFetchType.Online), fetchPreviewInfo({
                fileId: fileId,
                objKey: objKey
              }, PreviewInfoFetchType.Online)]);
            case 6:
              _yield$Promise$all = _context9.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              fileInfoRsp = _yield$Promise$all2[0];
              previewInfoRsp = _yield$Promise$all2[1];
              type = isAttachment(fileInfoRsp.data) ? DRIVE_TYPE.attachment : DRIVE_TYPE.drive;
              fileInfo = fileInfoRsp.data.result;
              previewInfo = previewInfoRsp.data.result;
              // TODO: 这里可以做这两个接口返回值的异常判断，直接进catch
              _context9.next = 19;
              break;
            case 15:
              _context9.prev = 15;
              _context9.t0 = _context9["catch"](3);
              this.log.error(DriveDataApi.TAG, '获取drive文件信息失败, message: ', _context9.t0);
              return _context9.abrupt("return", null);
            case 19:
              driveId = "".concat(fileId, "$").concat(objKey);
              driveData = {
                driveId: driveId,
                type: type,
                fileId: fileId,
                secretId: secretId,
                objKey: objKey,
                uid: (_getUid2 = getUid()) !== null && _getUid2 !== void 0 ? _getUid2 : '',
                lastRequestTime: Date.now(),
                fileInfo: fileInfo,
                previewInfo: previewInfo
              };
              return _context9.abrupt("return", driveData);
            case 22:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[3, 15]]);
      }));
      function requestDriveData(_x9) {
        return _requestDriveData.apply(this, arguments);
      }
      return requestDriveData;
    }()
  }]);
  return DriveDataApi;
}();
_defineProperty(DriveDataApi, "TAG", 'DriveDataApi');
var getPwaResFromDriveData = function getPwaResFromDriveData(driveData) {
  var _driveData$fileInfo$f, _driveData$fileInfo$f2;
  var staticList = [];
  var docsList = [];
  var isImg = isImageLike(driveData.fileInfo.mimeType);
  // TODO: 这里目前做了特殊处理
  // 1、因为pwa不支持相同链接不同query的存储，目前只缓存缩略图
  // 2、图片只缓存原图，其他只保存缩略图(视频资源太大)
  var resourceList = isImg ? [resolveUrl(driveData.previewInfo.preview_url)] : [(_driveData$fileInfo$f = (_driveData$fileInfo$f2 = driveData.fileInfo.fileMeta) === null || _driveData$fileInfo$f2 === void 0 ? void 0 : _driveData$fileInfo$f2.thumbnailUrl) !== null && _driveData$fileInfo$f !== void 0 ? _driveData$fileInfo$f : ''];
  resourceList.forEach(function (str) {
    if (!str) return;
    if (!isTencentDocHost(str)) staticList.push(str);else docsList.push(str);
  });
  return {
    staticList: staticList,
    docsList: docsList
  };
};
//# sourceMappingURL=drive-data-api.js.map